export default {
    "common.error.payment": "Une erreur est survenue lors de l'initialisation du paiement.",
    "common.error.portal": "Erreur lors de l'ouverture du portail : "
};
